import React, { useEffect, useState, useRef } from "react";
import Box from "@mui/material/Box";

import { DataGrid, useGridApiRef } from "@mui/x-data-grid";
import addProduct from "../utils/addProducts.png";
import deleteIcon from "../utils/delete.png";
import Tooltip from "@mui/material/Tooltip";
import notAllowedSymbol from "../utils/notAllowedSymbol.svg";
import { AiOutlinePlus } from "react-icons/ai";
import AssignJobModalEntryForm from "./AssignJobModalEntryForm";

const SubjobsGrid = ({ productEntries, setProductEntries }) => {
  console.log("productEntries Initial", productEntries);
  const [selectedRows, setSelectedRows] = useState([]);

  const toggleSelectAll = () => {
    if (selectedRows?.length === productEntries?.length) {
      setSelectedRows([]); // Unselect all if all are selected
    } else {
      setSelectedRows(productEntries?.map((_, index) => index)); // Select all rows
    }
  };

  // Toggle selection of a row
  const toggleRowSelection = (index) => {
    setSelectedRows(
      (prevSelectedRows) =>
        prevSelectedRows.includes(index)
          ? prevSelectedRows.filter((i) => i !== index) // Remove if already selected
          : [...prevSelectedRows, index] // Add if not selected
    );
  };

  // Delete selected rows
  const deleteSelectedRows = () => {
    const updatedEntries = productEntries.filter(
      (_, index) => !selectedRows.includes(index)
    );
    setProductEntries(updatedEntries);
    setSelectedRows([]); // Clear selection after deletion
  };

  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef(null);
  const slNoRef = useRef(null);
  const taskDescRef = useRef(null);
  const taskGroupRef = useRef(null);

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setShowDropdown(false);
    }
  };

  const [currentProductEntryRowId, setCurrentProductEntryRowId] =
    useState(null);
  const [currentProductTyping, setCurrentProductTyping] = useState(null);

  const handleAddRow = (e) => {
    e.preventDefault();

    const nextId =
      productEntries?.length > 0
        ? Math.max(...productEntries?.map((r) => r.id)) + 1
        : 1;

    const newRow = {
      id: nextId,
      taskDescription: "",
      taskGroup: "",
    };

    setProductEntries((prevEntries) => [...prevEntries, newRow]);
  };

  const handleInputChange = (id, field, value) => {
    console.log("id f v", id, field, value);

    setCurrentProductEntryRowId(id);

    // Set the current value being typed
    setCurrentProductTyping(value);
    if (field === "itemCode") {
      console.log("itemcode is set");
      //   fetchItemDetails(value, id); // Call your fetch function for item details
    }

    // Update the productEntries state with the new value
    let newArray = productEntries.map((item) => {
      if (item.id === id) {
        return {
          ...item,
          [field]: value,
          ...(field === "itemCode" && { isSelectedItemCodeCorrect: false }), // Set isSelectedItemCodeCorrect to false when itemCode changes
        };
      }
      return item;
    });

    // Set the updated productEntries array to state
    setProductEntries(newArray);
  };

  return (
    <div className="productsContainer rounded py-2  ">
      <div className="flex justify-between items-center mb-2">
        {/* <h2 className="text-xl font-thin">Subjobs List</h2> */}
        <h3 className="text-gray-700 font-medium ">Tasks</h3>
        <div className="flex gap-2">
          {/* <button className="p-1  rounded bg-blue-500" onClick={(e) => handleAddRow(e)}>
            <img src={addProduct} alt="addProduct-icon" className="w-4 h-4 p-[0.3] " />
          </button> */}
          <button
            onClick={(e) => handleAddRow(e)}
            className="flex items-center gap-1 px-3 py-1.5 bg-green-600 hover:bg-green-700 text-white text-sm rounded shadow transition"
          >
            <AiOutlinePlus className="w-4 h-4" />
            Add
          </button>
          {/* <button
            className={`p-2 ${selectedRows?.length === 0 ? "invisible" : ""}`}
            onClick={(e)=>handleDeleteSelected(e)}
          >
            <img src={deleteIcon} alt="delete-icon" className="w-4 h-4" />
          </button> */}
        </div>
      </div>
      <div className="">
        {selectedRows?.length > 0 && (
          <button
            onClick={deleteSelectedRows}
            disabled={selectedRows?.length === 0}
            className="px-3 py-1 bg-red-500 text-white rounded hover:bg-red-600 mb-2"
          >
            Delete Selected
          </button>
        )}
        <table className="min-w-full bg-white border border-gray-300   ">
          <thead className="">
            <tr className="bg-gray-200  rounded">
              <th className="border px-2 py-1 w-[20px] text-center">
                <input
                  className="rounded border border-sm shadow"
                  type="checkbox"
                  onChange={toggleSelectAll}
                  checked={
                    selectedRows?.length === productEntries?.length &&
                    productEntries?.length > 0
                  }
                />
              </th>
              <th className="px-1 py-0.5 font-normal w-[50px] border">Task Sl No</th>
              <th className="px-1 py-0.5 font-normal w-[100px] border">Task Group</th>
              <th className="px-1 py-0.5 font-normal w-[300px] border">Task</th>
            </tr>
          </thead>

          <tbody>
            {productEntries?.map((row, index) => (
              <tr key={index} className="text-sm">
                {console.log(
                  "productEntries in tabel: currentProductEntryRowId",
                  productEntries,
                  currentProductEntryRowId
                )}

                <td className=" border text-center">
                  <input
                    type="checkbox"
                    className="rounded border border-sm shadow"
                    checked={selectedRows.includes(index)}
                    onChange={() => toggleRowSelection(index)}
                  />
                </td>

                <td className=" border ">
                  <input
                    type="text"
                    ref={slNoRef}
                    // ref={taskDescRef}
                    id={row.Lead_ID || row.id}
                    // value={row.Prod_Description || row.itemDescription}
                    value={row.id}
                    onChange={(e) =>
                      handleInputChange(row.id, "id", e.target.value)
                    }
                    className="w-full p-1 border-none text-xs font-thin focus:outline-none focus:ring-0 text-left"
                  />
                </td>
                <Tooltip
                  // title={row.Prod_Description || row.itemDescription}
                  title={row.itemDescription}
                  arrow
                >
                  <td className=" border ">
                    <input
                      type="text"
                      // ref={slNoRef}
                      ref={taskDescRef}
                      id={row.Lead_ID || row.id}
                      value={row.Prod_Description || row.itemDescription}
                      onChange={(e) =>
                        handleInputChange(
                          row.id,
                          "itemDescription",
                          e.target.value
                        )
                      }
                      className="w-full p-1 border-none text-xs font-thin focus:outline-none focus:ring-0 text-left"
                    />
                  </td>
                </Tooltip>
                  <td className=" border ">
                    <input
                      type="text"
                      // ref={slNoRef}
                      ref={taskGroupRef}
                      id={row.Lead_ID || row.id}
                      value={row.Prod_Group || row.itemGroup}
                      onChange={(e) =>
                        handleInputChange(
                          row.id,
                          "itemGroup",
                          e.target.value
                        )
                      }
                      className="w-full p-1 border-none text-xs font-thin focus:outline-none focus:ring-0 text-left"
                    />
                  </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default SubjobsGrid;
